import React from "react";
import { Checkbox, CheckboxProps } from "@mui/material";
import styled from "styled-components";
import { CheckedIcon } from "../Icon/CheckedIcon";
import { UncheckedIcon } from "../Icon/UncheckedIcon";

export const StyledCheckBox = (props: CheckboxProps) => {
    return (
        <StyledCheckbox
            {...props}
            checkedIcon={<CheckedIcon />}
            icon={<UncheckedIcon />}
        />
    );
};

const StyledCheckbox = styled(Checkbox)`
    && {
        input {
            width: 24px;
            height: 24px;
        }
    }
`;
